import React from "react";
import { NavLink, Outlet, Navigate, useLocation } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/ui";

const TABS = [
  { to: "/", icon: "home", label: "Home" },
  { to: "/training", icon: "book-open", label: "Training" },
  { to: "/content", icon: "folder", label: "Content" },
  { to: "/crystals", icon: "hexagon", label: "Crystals" },
  { to: "/hq", icon: "user", label: "My HQ" },
];

export function RequireAuth({ children }) {
  const { user, token, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Loader />
      </div>
    );
  if (!token || !user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (!user?.is_admin) return <Navigate to="/" replace />;
  return children;
}

export function TabLayout() {
  const { colors } = useTheme();
  return (
    <div style={{ minHeight: "100vh", background: colors.surface }}>
      <div style={{ maxWidth: 720, margin: "0 auto", background: colors.surface, minHeight: "100vh", paddingBottom: 74, position: "relative" }}>
        <Outlet />
        <nav
          style={{
            position: "fixed",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            maxWidth: 720,
            display: "flex",
            background: colors.surface,
            borderTop: `1px solid ${colors.divider}`,
            paddingBottom: "env(safe-area-inset-bottom)",
            zIndex: 30,
          }}
        >
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === "/"}
              data-testid={`tab-${t.label.toLowerCase().replace(" ", "-")}`}
              style={({ isActive }) => ({
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 3,
                padding: "10px 0 12px",
                textDecoration: "none",
                color: isActive ? colors.brand : colors.muted,
              })}
            >
              {({ isActive }) => (
                <>
                  <Icon name={t.icon} size={22} color={isActive ? colors.brand : colors.muted} strokeWidth={isActive ? 2.4 : 2} />
                  <span style={{ fontSize: 11, fontFamily: fonts.text, fontWeight: isActive ? 700 : 500 }}>{t.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
